import { Components, Theme } from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    listButton: true;
    tooltip: true;
    cropperButton: true;
  }

  interface ButtonPropsColorOverrides {
    ["text.primary"]: true;
    ["text.secondary"]: true;
  }
}

export const MuiButton: Components<Theme>["MuiButton"] = {
  styleOverrides: {
    root: {
      textTransform: "none",
      letterSpacing: "0.64px",

      "&.MuiButton-colorPrimary[href]": {
        "&:hover": {
          color: "white", // Override Bootstrap's blue hover color
        },
      },
    },
  },
  variants: [
    {
      props: { variant: "listButton" },
      style: {
        width: "100%",
        justifyContent: "space-between",
        fontWeight: 400,
        letterSpacing: "normal",
        padding: "0.875rem 0 0 0",
        marginTop: "auto",
        "& .MuiSvgIcon-root": {
          transition: "transform 0.3s ease-in",
        },
        "&:hover": {
          color: "initial !important",
          "& .MuiSvgIcon-root": {
            transform: "translateX(6px)",
          },
        },
      },
    },
    {
      props: { variant: "cropperButton" },
      style: () => ({
        border: "1px solid #BDBDBD",
        color: "#000000DE",
        padding: "4px",
        width: "100%",
        borderRadius: "5px",
        textAlign: "center",
        fontSize: "12px",
        lineHeight: "22px",
        fontWeight: "700",
      }),
    },
  ],
};
